let BASE_URL="https://erin-relieved-seahorse.cyclic.app/"



export { BASE_URL };
